import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { longTestimonials, shortTestimonials } from '../data/testimonials';
import { stats } from '../data/copy';
function Stars() {
  return <div className="flex gap-1 text-brand-gold" aria-label="5 de 5 estrellas" data-id="element-168" data-mp="3grj75qve3xsi">
      {[1, 2, 3, 4, 5].map(item => <StarIcon key={item} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-169" data-mp="3bqbxfm9osoj7" />)}
    </div>;
}
export function StatsAndProof() {
  return <>
      <section className="border-y border-brand-green/20 bg-brand-ink px-4 py-14 sm:py-20" data-id="element-170" data-mp="3lqmbf93jpzzf">
        <div className="mx-auto grid max-w-3xl grid-cols-2 gap-x-5 gap-y-10" data-id="element-171" data-mp="3cd6x05hhvd3">
          {stats.map(([value, label]) => <div key={label} className="text-center" data-id="element-172" data-mp="3vgxhb16sij8y">
              <p className="font-display text-4xl font-bold sm:text-6xl" data-id="element-173" data-mp="da121r7054vs">{value}</p>
              <p className="mt-2 text-xs font-semibold leading-tight text-brand-light sm:text-sm" data-id="element-174" data-mp="d7oij9llimgm">
                {label}
              </p>
            </div>)}
        </div>
      </section>

      <section className="bg-brand-dark px-4 py-16 sm:py-20" data-id="element-175" data-mp="1gf7lzf9vpwhp">
        <div className="mx-auto grid max-w-6xl gap-5 md:grid-cols-3" data-id="element-176" data-mp="1lcr0mgahoba6">
          {shortTestimonials.map((item, index) => <motion.article key={item.name} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05,
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-2xl border border-white/10 bg-brand-ink p-6" data-id="element-177" data-mp="1qd591zg05n8q" data-mpi={index}>
              <div className="flex items-center gap-3" data-id="element-178" data-mp="292brdlcvwcu0">
                <div className="grid h-11 w-11 place-items-center rounded-full border border-brand-green/40 font-bold text-brand-light" data-id="element-179" data-mp="2e0wkz1xmry9h">
                  {item.initials}
                </div>
                <div data-id="element-180" data-mp="2n0rw56r6rt9i">
                  <h3 className="font-bold" data-id="element-181" data-mp="2n232nec0nf4b">{item.name}</h3>
                  <p className="text-sm text-slate-400" data-id="element-182" data-mp="mysevegokbzy">{item.place}</p>
                </div>
              </div>
              <div className="mt-5" data-id="element-183" data-mp="iy04ghw2o123">
                <Stars data-id="element-184" data-mp="iz1j0wcar5ok" />
              </div>
              <p className="mt-4 italic leading-relaxed text-slate-300" data-id="element-185" data-mp="wolfjkfab6pf">“{item.quote}”</p>
            </motion.article>)}
        </div>
      </section>
    </>;
}
export function ExtendedTestimonials() {
  return <section className="border-y border-white/10 bg-brand-dark px-4 py-14 sm:py-20" data-id="element-186" data-mp="16m9lz7m962nf">
      <div className="mx-auto max-w-5xl" data-id="element-187" data-mp="11ohj5ik2kw4g">
        <h2 className="mb-10 text-center font-display text-2xl font-bold text-brand-light sm:text-3xl" data-id="element-188" data-mp="11ng5r7fkzxjk">
          LO QUE DICEN QUIENES YA LO ESTÁN APLICANDO
        </h2>
        <div className="grid gap-7 md:grid-cols-2" data-id="element-189" data-mp="1aoeeu44vmv90">
          {longTestimonials.map(item => <article key={item.name} className="border-l-2 border-brand-green pl-4" data-id="element-190" data-mp="3heauryjwguin">
              <Stars data-id="element-191" data-mp="3cgj1b03lx0cc" />
              <p className="mt-2 font-bold" data-id="element-192" data-mp="3ch2kek4ztury">
                {item.name} <span className="font-normal text-slate-400" data-id="element-193" data-mp="1rxyqzglbyx3d">· {item.place}</span>
              </p>
              <p className="mt-2 text-sm italic leading-relaxed text-slate-300" data-id="element-194" data-mp="1wx1wt394x7ce">{item.quote}</p>
            </article>)}
        </div>
      </div>
    </section>;
}